import { Chip } from '@mui/material';
import { ItemState } from '@/api/graphql';
import { getStateColor, humaniseState } from '@/utils';

/** Outlined chip coloured by state — the CVDS pattern. */
export default function StateChip({ state }: { state: ItemState }) {
  const color = getStateColor(state);

  return (
    <Chip
      size="small"
      variant="outlined"
      label={humaniseState(state)}
      sx={{ color, borderColor: color, minWidth: 140 }}
    />
  );
}
